export default {
  FETCH_PHONE_LINES_SUCCESS: 'FETCH_PHONE_LINES_SUCCESS',
  TOGGLE_PHONE_LINES_EDITING: 'TOGGLE_PHONE_LINES_EDITING',
  UPDATE_PHONE_LINES: 'UPDATE_PHONE_LINES',
  UPDATE_PHONE_LINE_ALIAS: 'UPDATE_PHONE_LINE_ALIAS',
  SET_PHONE_LINES: 'SET_PHONE_LINES',
  RESET_PHONE_LINES: 'RESET_PHONE_LINES',

  FETCH_DETAILED_USAGES: 'FETCH_DETAILED_USAGES',
  FETCH_DETAILED_USAGES_SUCCESS: 'FETCH_DETAILED_USAGES_SUCCESS',

  FETCH_USAGE_AGGREGATE: 'FETCH_USAGE_AGGREGATE',
  FETCH_USAGE_AGGREGATE_SUCCESS: 'FETCH_USAGE_AGGREGATE_SUCCESS',

  FETCH_USAGES: 'FETCH_USAGES',
  FETCH_USAGES_SUCCESS: 'FETCH_USAGES_SUCCESS',
  FETCH_USAGES_FAILURE: 'FETCH_USAGES_FAILURE',

  REDIRECT_AFTER_USAGE_FRAME_ON_TITLE_PRESS: 'REDIRECT_AFTER_USAGE_FRAME_ON_TITLE_PRESS',
  RESET_USAGE: 'RESET_USAGE',
  UPDATE_USAGE_DISPLAY_MODE: 'UPDATE_USAGE_DISPLAY_MODE',

  SWITCH_MODE_REQUEST: 'SWITCH_MODE_REQUEST',
  SWITCH_MODE_SUCCESS: 'SWITCH_MODE_SUCCESS',
  SWITCH_MODE_FAILURE: 'SWITCH_MODE_FAILURE',

  INIT_TOP_UP: 'INIT_TOP_UP',
  CLEAR_TOP_UP: 'CLEAR_TOP_UP',

  FETCH_PAYMENTS_SUCCESS: 'FETCH_PAYMENTS_SUCCESS',

  FOCUS: 'FOCUS',

  ADD_TOP_UP_TO_SELECTION: 'ADD_TOP_UP_TO_SELECTION',

  FETCH_NOTIFICATIONS_SUCCESS: 'FETCH_NOTIFICATIONS_SUCCESS',
  SEE_NOTIFICATION_REQUEST: 'SEE_NOTIFICATION_REQUEST',
  SEE_NOTIFICATION_SUCCESS: 'SEE_NOTIFICATION_SUCCESS',
  SEE_NOTIFICATION_FAILURE: 'SEE_NOTIFICATION_FAILURE',
};
